import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { Box, Typography } from '@mui/material';
import { getUserFullName } from '../../../helpers/user';
import { formatAddress } from '../../../helpers/formatters';
import { MARKER_DONOR, MARKER_RECEIVER } from '../../Map/Components/MarkersSelector';

const LocationSearch = ({ showDonors, showReceivers, handleLocationChange, locations = [] }) => {
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const loadSuggestionsMinChars = 2;

  const getUserName = (option) => option?.title || option?.name || getUserFullName(option);

  const getUserLabel = (option) => {
    const formattedAddress = option
      ? formatAddress({
          address: option?.address,
          city: option?.city,
          st: option?.st,
          zip: option?.zip,
        })
      : null;

    if (formattedAddress && !getUserName(option)) {
      return formattedAddress;
    }

    return getUserName(option);
  };

  useEffect(() => {
    if (searchValue.length <= loadSuggestionsMinChars) {
      return setLocationsOptions([]);
    }

    const filteredOptions = locations.filter((option) => {
      return getUserLabel(option).toLowerCase().includes(searchValue.toLowerCase());
    });

    if (showDonors) {
      const donorOptions = filteredOptions.filter((option) => option.type === MARKER_DONOR);
      return setLocationsOptions(donorOptions);
    }

    if (showReceivers) {
      const receiverOpitons = filteredOptions.filter((option) => option.type === MARKER_RECEIVER);
      return setLocationsOptions(receiverOpitons);
    }

    return setLocationsOptions(filteredOptions);
  }, [searchValue]);

  const onInputChange = (option, { action }) => {
    if (action === 'input-change') {
      setSearchValue(option);
    } else {
      setSearchValue('');
    }
  };

  const renderOption = (option, { selectValue = [] }) => {
    const isSelected = selectValue.find((user) => user?.id === option?.id);

    if (isSelected) {
      return getUserLabel(option);
    }

    if (!getUserName(option)) {
      return (
        <Typography gutterBottom variant="body1">
          {formatAddress({
            address: option.address,
            city: option.city,
            st: option.st,
            zip: option.zip,
          })}
        </Typography>
      );
    }

    return (
      <Box display="flex" flexDirection="column" pb={1}>
        <Typography variant="body1">{getUserName(option)}</Typography>
        {(option.type === MARKER_DONOR || option.type === MARKER_RECEIVER) && (
          <Typography color="textSecondary" variant="body2">
            {formatAddress({
              address: option.address,
              city: option.city,
              st: option.st,
              zip: option.zip,
            })}
          </Typography>
        )}
      </Box>
    );
  };

  return (
    <ReactSelect
      isDisabled={!locations.length}
      placeholder={showDonors ? 'Search for a donor' : 'Search for an agency'}
      options={locationsOptions}
      value={null}
      formatOptionLabel={renderOption}
      getOptionLabel={(option) => getUserLabel(option)}
      onInputChange={onInputChange}
      getOptionValue={(option) => option?.meta?.id}
      onChange={handleLocationChange}
      noOptionsMessage={() =>
        searchValue.length <= loadSuggestionsMinChars ? 'Type the 3 first letters to see results' : 'Location not found'
      }
    />
  )
};

export default LocationSearch;
